import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasAssistanceSchema = withDefaults({
  type: 'tas-assistance',
  objectExtensions: ['tas-assistance'],
  fields: [
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'grossAmount',
    },
    {
      kind: 'attribute',
      name: 'effectiveAmount',
    },
    {
      kind: 'attribute',
      name: 'feeAmount',
    },
    {
      kind: 'attribute',
      name: 'approvals',
    },
    {
      kind: 'attribute',
      name: 'manner',
    },
    {
      kind: 'attribute',
      name: 'fields',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'attribute',
      name: 'courseCashExpiresAt',
    },
    {
      kind: 'attribute',
      name: 'digests',
    },
    {
      kind: 'attribute',
      name: 'merchantName',
    },
    {
      kind: 'belongsTo',
      name: 'tasApplication',
      type: 'tas-application',
      options: {
        async: false,
        inverse: 'tasAssistances',
      },
    },
    {
      kind: 'hasMany',
      name: 'attachments',
      type: 'attachment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'tasAssets',
      type: 'tas-asset',
      options: {
        async: false,
        inverse: 'tasAssistances',
      },
    },
    {
      kind: 'hasMany',
      name: 'approvables',
      type: 'tas-approvable',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsFeeDisambiguation',
      type: 'pcs-fee-disambiguation',
      options: {
        async: false,
        inverse: 'tasAssistance',
      },
    },
  ],
});

export default TasAssistanceSchema;
